import { ReactComponent as LogoSvg } from '../../images/icons/copilot.svg';
import util from '../../utils/utils';
import { useNavigate, useLocation } from 'react-router-dom';
import { useStore } from '../../views/Policy/StoreContext';
import { useConfig } from '../../contexts/ConfigContext';

function Header() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { state, actions } = useStore();
    const { clientId } = useConfig();

    return (
        <div className={`z-50 ${clientId === 'client-b' ? 'glass' : 'bg-white'}`}>
            <div className={`z-50 ${clientId === 'client-b' ? 'glass' : ''}`}>
                <div class="navbar">
                    <div class="navbar-start">
                        <div class="dropdown lg:hidden">
                            <label tabIndex="0" class="btn btn-ghost">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                            </label>
                            <ul tabIndex="0" class="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
                                <li ><a className={`${pathname.includes('/policy') ? 'active' : null} text-neutral`} onClick={() => navigate('/policy')}>政策通</a></li>
                                {process.env.REACT_APP_TYPE !== 'grid-build' && <li ><a className={`${pathname === '/think-tank-abroad' ? 'active' : null} text-neutral`} onClick={() => navigate('/think-tank-abroad')}>海外智库洞察</a></li>}
                                <li className={`${pathname === '/collections' ? 'active' : null} text-neutral`} onClick={() => navigate('/collections')}><a>收藏夹</a></li>
                            </ul>
                        </div>
                        <ul className="menu lg:menu-horizontal w-1024 hidden lg:flex items-center">
                            <li>
                                <a className={`font-bold mr-8 cursor-pointer`} onClick={() => navigate('/policy')}>
                                    <div className={`${pathname.includes('/policy') ? 'text-black' : 'text-secondary'} text-lg`}>
                                        政策通
                                    </div>
                                </a>
                            </li>
                            {/* {process.env.REACT_APP_TYPE !== 'grid-build' && 
                        <>
                        <span className='mr-8'>/</span>

                        <li>
                            <a className={`font-bold mr-8 cursor-pointer`} onClick={()=>navigate('/think-tank-abroad')}>
                            <div className={`${pathname === '/think-tank-abroad' ? 'text-black' : 'text-secondary'} text-lg`}>
                                海外智库洞察
                            </div>
                            </a>
                        </li>
                        </>
                        } */}
                            <span className='mr-8'>/</span>
                            <li>
                                <a className={`font-bold mr-8 cursor-pointer`} onClick={() => navigate('/collections')}>
                                    <div className={`${pathname === '/collections' ? 'text-black' : 'text-secondary'} text-lg`}>
                                        收藏夹
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* 用户登录状态和退出登录按钮 - 放在最右侧 */}
                    <div class="navbar-end">
                        {util.getStorage(process.env.REACT_APP_LOCALSTORAGE_NAME) ?
                            // 在a环境下隐藏退出登录按钮
                            clientId !== 'client-a' && (
                                <button
                                    className="btn btn-ghost text-black"
                                    onClick={() => {
                                        util.removeStorage(process.env.REACT_APP_LOCALSTORAGE_NAME);
                                        window.location.href = process.env.REACT_APP_DOMAIN;
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
                                    </svg>
                                    退出登录
                                </button>
                            )
                            :
                            // 在a环境下隐藏去登录按钮
                            clientId !== 'client-a' && (
                                <button
                                    className="btn btn-primary shadow-lg hover:shadow-xl transition-all duration-200 text-white font-medium"
                                    onClick={() => {
                                        // ✅ 修复：跳转到登录页面，并保存当前页面作为returnUrl
                                        const currentUrl = encodeURIComponent(window.location.pathname + window.location.search);
                                        navigate(`/login?returnUrl=${currentUrl}`);
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                                    </svg>
                                    去登录
                                </button>
                            )
                        }
                    </div>
                </div>
            </div>

        </div>

        // <div className="pb-12 bg-neutral px-6" style={{background:'#20558a'}}>
        //     <div class="navbar text-neutral-content">
        //         <div class="dropdown">
        //         <label tabindex="0" class="btn btn-ghost lg:hidden">
        //             <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
        //         </label>
        //         <ul tabindex="0" class="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
        //             <li ><a className={`${pathname === '/policy' ? 'active' : null} text-neutral`} onClick={()=>navigate('/policy')}>政策洞察</a></li>
        //             <li ><a className={`${pathname === '/policy' ? 'active' : null} text-neutral`} onClick={()=>navigate('/think-tank-abroad')}>海外智库洞察</a></li>
        //             {/* <li className="disabled text-neutral"><a>写作助手</a></li> */}
        //             <li className={`${pathname === '/policy' ? 'active' : null} text-neutral`} onClick={()=>navigate('/collections')}><a>收藏夹</a></li>
        //         </ul>
        //         </div>
        //         <label tabindex="0" class="btn btn-ghost font-bold text-xl">
        //             <LogoSvg/>
        //             <span className='hidden sm:block'>
        //                 Research Copilot
        //             </span>
        //         </label>
        //     </div>
        //     <div class="navbar-center hidden lg:flex">
        //     <ul className="menu lg:menu-horizontal w-1024">
        //         <li>
        //             <a className={`font-bold mr-8 cursor-pointer ${pathname === '/policy' ? 'active' : ''}`} onClick={()=>navigate('/policy')}>
        //             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5 text-neutral-content">
        //             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z" />
        //             </svg>
        //             <div className='text-lg text-neutral-content'>
        //                 政策洞察
        //             </div>
        //             </a>
        //         </li>
        //         <li>
        //             <a className={`font-bold mr-8 cursor-pointer ${pathname === '/think-tank-abroad' ? 'active' : ''}`} 
        //             // style={pathname === '/think-tank-abroad' ? {background:'#4e5065'} : null}  
        //             onClick={()=>navigate('/think-tank-abroad')}>
        //             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-neutral-content">
        //             <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5" />
        //             </svg>
        //             <div className='text-lg text-neutral-content'>
        //                 海外智库洞察
        //             </div>
        //             </a>
        //         </li>
        //         {/* <li>
        //             <a className="font-bold mr-8">
        //             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5 text-neutral-content">
        //             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
        //             </svg>
        //             <div className='text-lg text-neutral-content'>
        //                 写作助手
        //             </div>
        //             </a>
        //         </li> */}
        //         <li> 
        //             <a className={`font-bold mr-8 cursor-pointer ${pathname === '/collections' ? 'active' : ''}`} 
        //             onClick={()=>navigate('/collections')}>
        //             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5 text-neutral-content">
        //             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.563.563 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
        //             </svg>
        //             <div className='text-lg text-neutral-content'>
        //                 收藏夹
        //             </div>
        //             </a>
        //         </li>
        //     </ul>
        //     </div>
        //     <div class="navbar-end">
        //         <div className="mr-2">{util.getUserName()}</div>
        //         <div className="dropdown dropdown-end">
        //             <div tabIndex={0} role="button" className="btn btn-ghost btn-circle">
        //                 <div className="indicator">
        //                     <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        //                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
        //                     </svg>
        //                 </div>
        //                 </div>
        //                 <ul tabIndex={0} className="menu dropdown-content z-[1] p-2 shadow bg-base-100 text-neutral-content rounded-box w-28 mt-1">
        //                     <li><a className='text-neutral' onClick={()=>{util.removeStorage('research_copilot_user_info');window.location.href = process.env.REACT_APP_DOMAIN}}>退出登录</a></li> 
        //                 </ul>
        //             </div>
        //         </div>
        //     </div>

        // </div>
    )
}

export default Header